import { IAppState } from '../../redux';
import { TSelectedRecommendedPackageId } from '../../types/reducers/recommendedPackages';

export function selectSelectedRecommendedPackageId(state: IAppState): TSelectedRecommendedPackageId {
  return state.recommendedPackages.selectedPackageId;
}
